<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'formkeyvalue',
})
</script>
<template>
<div>
  <draggable :list="data" itemKey="id" element="ul" @end="onEnd">
      <template #item="{ element,index }">
                  <li class="flex align-center padding-sm devider">
                    <div class="flex1" @click="edit(element,index)">
                      <a-space class="padding-sm" v-for="(it,u) in props.rules" :key="u">
                      <span>{{ it.name }}</span> :
                      <img :src="baseURL+element[u]"  v-if="it.domtype=='img'&&element[u]" />
                      <span v-else class="text-bold">{{element[u]}}</span>
                    </a-space>
                    </div>
                    <CloseCircleOutlined class="text-primary text-lg" @click="del(index)" />
                  </li>
    </template>
  </draggable>

  <div class="text-center">
  <PlusSquareOutlined @click="add" class="margin-tb text-primary  text-xl"  />
  </div>
  <a-modal v-model:open="open" title="编辑" @ok="ok">
      <a-form v-if="props.rules&&model">
      <a-form-item :label="item.name" v-for="(item,k) in props.rules" :key="k">
        <a-input-number v-model:value="model[k]" v-if="item.domtype=='number'"></a-input-number>
        <LanseedUploadimg :max="1" v-model:value="model[k]" v-else-if="item.domtype=='img'"></LanseedUploadimg>
        <a-input v-model:value="model[k]" v-else></a-input>
      </a-form-item>
      </a-form>
  </a-modal>
</div>
</template>
<script setup lang="ts" name="formkeyvalue">
import { watch,defineProps,ref } from 'vue';
import {CloseCircleOutlined,PlusSquareOutlined} from '@ant-design/icons-vue'
import LanseedUploadimg from './uploadimg.vue'
import { baseURL } from '@/utils/util'
import draggable from 'vuedraggable'

const emit=defineEmits(['update:value'])
const data=ref<any>([]);
const props=defineProps({
  value:{type:Array},
  rules:{type:Object}
});
const open=ref<Boolean>(false)
const model=ref<any|null>(null);
const add=()=>{
  var o={}
  for(var k in props.rules){
    o[k]=""
  }
  model.value=o
  open.value=true
}
const ok=():void=>{
  if(model.value.hasOwnProperty("ID")){
    var index=data.value.findIndex(e=>{return e.ID==model.value.ID})
    data.value[index]=model.value
  }else{
    data.value.push(model.value)
  }
  model.value=null
  open.value=false
  emit('update:value',data.value)
}
const edit=(item,i)=>{
  model.value=item
  open.value=true
  console.info('MODEL',item,model.value)
}
const del=(i:number)=>{
  data.value.splice(i,1)
  emit('update:value',data.value)
}
const onEnd=(e:Event)=>{

}
watch(()=>props.value,(n)=>{
  if(n){
    data.value=n
  }
},{immediate:true})
</script>
